export default __webpack_public_path__ + "static/media/500.b3ccd714.png";